import Vue from "vue";
import Router, { NavigationGuard } from "vue-router";
import Home from "./views/Home.vue";
import Account from "./views/Account.vue";
import Contact from "./views/Contact.vue";
import Location from "./views/Location.vue";
import ProgramIndoor from "./views/ProgramIndoor.vue";
import ProgramOutdoor from "./views/ProgramOutdoor.vue";
import Registration from "./views/Registration.vue";
import Login from "./views/Login.vue";
import RegNotOpen from "./views/RegNotOpen.vue";
import Rules from "./views/Rules.vue";
import Mail from "./views/Mail.vue";
import Admin from "./views/Admin.vue";
import store from "@/store";

Vue.use(Router);

const authorizationGuard: NavigationGuard = (to, from, next) => {
	const u = store.state.user;
	if (!u)
		next("/login");
	// else if ((Date.now() < regStart) && !u.admin)
	// 	next("regnotopen");
	else
		next();
};

const alreadyAuthorizedGuard: NavigationGuard = (to, from, next) => {
	const u = store.state.user;
	if (u)
		next("/registration");
	else
		next();
};
const adminGuard: NavigationGuard = (to, from, next) => {
	const u = store.state.user;
	if (!u || !u.admin)
		next("/home");
	else
		next();
};

export default new Router({
	mode: "history",
	base: process.env.BASE_URL,
	routes: [
		{
			name: "root",
			path: "/",
			redirect: "/home",
		},
		{
			path: "/home",
			name: "home",
			component: Home,
		},
		{
			path: "/contact",
			name: "contact",
			component: Contact,
		},
		{
			path: "/location",
			name: "location",
			component: Location,
		},
		{
			path: "/program_indoor",
			name: "programIndoor",
			component: ProgramIndoor,
		},
		{
			path: "/program_outdoor",
			name: "programOutdoor",
			component: ProgramOutdoor,
		},
		{
			path: "/registration",
			name: "registration",
			component: Registration,
			beforeEnter: authorizationGuard,
		},
		{
			path: "/account",
			name: "account",
			component: Account,
			beforeEnter: authorizationGuard,
		},
		{
			path: "/login",
			name: "login",
			component: Login,
			beforeEnter: alreadyAuthorizedGuard,
			meta: {
				isLogin: true,
			},
		},
		{
			path: "/rules",
			name: "rules",
			component: Rules,
		},
		{
			path: "/regnotopen",
			name: "regnotopen",
			component: RegNotOpen,
		},
		{
			path: "/mail/:id/:type/:token",
			name: "mail",
			component: Mail,
		},
		{
			path: "/admin",
			name: "admin",
			component: Admin,
			beforeEnter: adminGuard,
		},
	],
});
